import * as React from 'react';
import { Link } from 'react-router-dom';
import './NavigationAdmin.css';
import { Navigation } from '../Navigation/Navigation';

export interface Props {
}

interface State {
}

export class NavigationAdmin extends React.Component {
  state: State;
  props: Props;

  constructor(props: Props) {
    super(props);
  }

  render() {
    const logoStyle = {
          paddingRight: '10px',
          paddingBottom: '5px',
    };
    return (
      <Navigation>
        <Link
            className="nav-link text-black-50 "
            style={{ fontSize: '18px', paddingTop: '20px', fontWeight: 'normal', height: '60px'}}
            to="/home"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/home-small.png')}
                className="img-responsive"
                alt="Logo"
            />
            Accueil
        </Link>
        <Link
            className="nav-link text-black-50 "
            style={{ fontSize: '18px', paddingTop: '20px', fontWeight: 'normal', height: '60px'}}
            to="/profile"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/user-small.png')}
                className="img-responsive"
                alt="Logo"
            />
            Profil
        </Link>
          <Link
              className="nav-link text-black-50 "
              style={{ fontSize: '18px', paddingTop: '20px', fontWeight: 'normal', height: '60px'}}
              to="/medias"
          >
              <img
                  style={logoStyle}
                  src={require('../../../genericComponents/Images/picture-small.png')}
                  className="img-responsive"
                  alt="Logo"
              />
              Medias
          </Link>
          <Link
              className="nav-link text-black-50 "
              style={{ fontSize: '18px', paddingTop: '20px', fontWeight: 'normal', height: '60px'}}
              to="/schedule"
          >
              <img
                  style={logoStyle}
                  src={require('../../../genericComponents/Images/calendar-small.png')}
                  className="img-responsive"
                  alt="Logo"
              />
              Planning
          </Link>
          <Link
              className="nav-link text-black-50 "
              style={{ fontSize: '18px', paddingTop: '20px', fontWeight: 'normal', height: '60px'}}
              to="/courses"
          >
              <img
                  style={logoStyle}
                  src={require('../../../genericComponents/Images/course.png')}
                  className="img-responsive"
                  alt="Logo"
              />
              Cours
          </Link>
        <Link
            className="nav-link text-black-50 "
            style={{ fontSize: '18px', paddingTop: '20px', fontWeight: 'normal', height: '60px'}}
            to="/userlist"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/team.png')}
                className="img-responsive"
                alt="Logo"
            />
            Utilisateurs
        </Link>
        <Link
            className="nav-link text-black-50 "
            style={{ fontSize: '18px', paddingTop: '20px', fontWeight: 'normal', height: '60px'}}
            to="/subscriptions"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/folder.png')}
                className="img-responsive"
                alt="Logo"
            />
            Inscriptions
        </Link>
        <Link
            className="nav-link text-black-50 "
            style={{ fontSize: '18px', paddingTop: '20px', fontWeight: 'normal', height: '60px'}}
            to="/gestion-media"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/eye.png')}
                className="img-responsive"
                alt="Logo"
            />
            Gestion des médias
        </Link>
      </Navigation>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Navigation/NavigationAdmin/NavigationAdmin.tsx